<div class="display-direction-row">
  <button id="{{baseId}}-remove-button"
          class="btn btn-light max-items-button"
          [ngClass]="{'error': currentValueFormControl.invalid && form?.submitted}"
          type="button"
          [disabled]="currentValueFormControl !== null && currentValueFormControl.value <= minValue"
          (click)="onDecrementValueClick()">
    <span class="menu-chevron material-icons">remove</span>
  </button>
  <input id="{{baseId}}-current-value"
         class="form-control max-items-input"
         [ngClass]="{'error': currentValueFormControl.invalid && form?.submitted}"
         type="text"
         inputmode="numeric"
         [apNumberValidation]="'integer'"
         [formControl]="currentValueFormControl">
  <button id="{{baseId}}-add-button"
          class="btn btn-light max-items-button"
          [ngClass]="{'error': currentValueFormControl.invalid && form?.submitted}"
          type="button"
          [disabled]="currentValueFormControl !== null && currentValueFormControl.value >= maxValue"
          (click)="onIncrementValueClick()">
    <span class="menu-chevron material-icons">add</span>
  </button>
</div>
<div *ngIf="currentValueFormControl">
  <div *ngIf="isRequired() && form?.submitted && currentValueFormControl.errors && currentValueFormControl.errors.required"
       id="{{baseId}}-warning-text-value-required"
       class="incorrect-input" translate>
    Please enter a numerical value.
  </div>
</div>
